
/**
 * 处理启动分析模块的数据
 */
const initiateAnalysisModule = {
	namespaced: true,
	state: {
    triggerInitiateAnalysisData: {
			celeScopeFiles: [],
			cellFilteringTaskStatus: "",
			datasetId: "",
			datasets: [],
			groupId: "",
			id: 0,
			matrixFiles: [],
			metadataFile: {
				columns: [],
				tableData: [],
			},
			mitochondrialGeneSet: {
				fileName: "",
				geneSet: [],
				preSelected: true,
			},
			pageTag: "",
			param: {
				algorithm: "",
				annotationType: "",
				basedOnSingleSamples: [],
				batchName: "",
				batchRemoveMethod: "",
				cellFilteringEvaluation: "skip",
				cellQualityAdjustments: [],
				cluster: 0,
				contaminationState: "",
				doubletState: "",

				jobName: "",

				numberOfHighlyVariableGenes: 0,
				pcValueNum: 0,
				pcValueState: "",
				reference: "",
				species: "",
				tissue: "",

				geneRange: [],
				geneState: "",
				umiRange: [],
				umiState: "",
				mitochondrial: 0,
				mitochondrialState: "",
				ribosomal: 0,
				cellCounts: 0,
				computeResource: 'cpu',
			},
			ribosomalGeneSet: {
				fileName: "",
				geneSet: [],
				preSelected: true,
			},
			stepTag: '0',
		},  // 保存启动分析的数据
    editTaskRequireData: {  // 编辑任务所需数据
			datasetId: '',
			groupId: '',
			id: 0,
    },

		activeStep: '0', // 当前步骤
		cellFilteringTaskStatus: '', // 细胞过滤任务状态
		cellFilteringEvaluation: 'skip', // 细胞过滤评估
		skipCellFilteringData:{ // 跳过细胞过滤数据
			geneRange: [
        200,
        5000,
			],
			geneState: "recommended",
			umiRange: [
					0,
					30000,
			],
			umiState: "recommended",
			mitochondrial: 50,
			mitochondrialState: "recommended",
			ribosomal: 50,
		},
		doCellFilteringData:{ // 细胞过滤数据
			geneRange: [
				200,
				5000,
			],
			geneState: "recommended",
			umiRange: [
					0,
					30000,
			],
			umiState: "recommended",
			mitochondrial: 50,
			mitochondrialState: "recommended",
			ribosomal: 50,
		},
	},
	mutations: {

    changeTriggerInitiateAnalysisDataM(state, data) {
      state.triggerInitiateAnalysisData = data;
    },

    changeEditTaskRequireDataM(state, data) {
      state.editTaskRequireData = data;
    },

		changeActiveStepM(state, step) {
			state.activeStep = step;
			state.triggerInitiateAnalysisData.stepTag = step;
		},

		changeCellFilteringTaskStatusM(state, status) {
			state.cellFilteringTaskStatus = status;
			state.triggerInitiateAnalysisData.cellFilteringTaskStatus = status;
		},

		changeCellFilteringEvaluationM(state, evaluation) {
			state.cellFilteringEvaluation = evaluation;
			state.triggerInitiateAnalysisData.param.cellFilteringEvaluation = evaluation;
		},

		changeSkipCellFilteringDataM(state, data) {
			state.skipCellFilteringData = data;
		},
		changeDoCellFilteringDataM(state, data) {
			state.doCellFilteringData = data;
		},
	},
	actions: {

		changeTriggerInitiateAnalysisDataA({ commit }, data) {
			commit('changeTriggerInitiateAnalysisDataM', data);
		},

    changeEditTaskRequireDataA({ commit }, data) {
      commit('changeEditTaskRequireDataM', data);
    },

		// 改变当前步骤
		changeActiveStepA({ commit }, step) {
			commit('changeActiveStepM', step);
		},

		// 改变数据预处理任务状态
		changeCellFilteringTaskStatusA({ commit }, status) {
			commit('changeCellFilteringTaskStatusM', status);
		},

		// 改变细胞过滤评估状态
		changeCellFilteringEvaluationA({ commit }, evaluation) {
			commit('changeCellFilteringEvaluationM', evaluation);
		},

		// 改变细胞过滤评估跳过数据
		changeSkipCellFilteringDataA({ commit }, data) {
			commit('changeSkipCellFilteringDataM', data);
		},
		// 改变细胞过滤评估数据
		changeDoCellFilteringDataA({ commit }, data) {
			commit('changeDoCellFilteringDataM', data);
		},
	},
};

export default initiateAnalysisModule;
